export default __webpack_public_path__ + "static/media/NovaBot_logo.08347f73.svg";